module.exports = __webpack_public_path__ + "static/revfig2-df42cf6b23ae6e6a3c305a19468dfa33.svg";